export function progressStatus(pct) {
    if (pct === null || pct === undefined || Number.isNaN(pct))
        return "to_evaluate";
    if (pct <= 0)
        return "not_started";
    if (pct >= 100)
        return "done";
    return "in_progress";
}
/** Need / shortage line states (PRD M07-03). */
export const NEED_STATES = [
    "reported",
    "validated_by_chef",
    "sent_to_purchasing",
    "in_stock",
    "ordered",
    "delivered_to_site",
    "closed",
    "rejected",
    "deferred",
];
export const NEED_PRIORITIES = ["normal", "urgent", "blocking"];
export const STOCK_MOVEMENT_TYPES = ["receipt", "issue_to_site", "transfer", "return", "consumption", "adjustment", "loss"];
export const PURCHASE_ORDER_STATES = ["draft", "sent", "partially_received", "received", "cancelled"];
export const PURCHASE_LIST_STATES = ["draft", "sent", "processing", "closed"];
export const DOCUMENT_TYPES = ["FAC", "CTR", "CTR_AR", "BC", "PVR", "SIT", "OM", "LA", "BS", "FS", "RJ", "DDV"];
export const DOCUMENT_STATES = ["draft", "issued", "signed", "cancelled"];
//# sourceMappingURL=status.js.map